/* ==========================================================================
   Dynoforce zoekbalk met auto's

   De zoekbalk toonde alleen producten, en Shopify matcht op elk woord apart:
   "bmw m4 g82" gaf duizend losse delen en nooit de auto zelf. Dit script
   herkent in de zoekterm een auto (merk, modelnaam, chassiscode, bouwjaar),
   een onderdeel (bodykit, splitter, skirts, ...) of een kenteken, en zet dat
   als eerste blok in het uitklapmenu en bovenaan de resultatenpagina.

   De autolijst is dezelfde als die van de autokiezer in de menubalk
   ([data-dfa-autos], 160 regels met merk, modelgroep, label en url), dus er
   komt geen opvraging bij. Herkenning werkt zoals de zoekbalk op /collections:
   op woordbegin, met samentrekkingen ("rs 3" en "rs3"), en als terugval op
   de aaneengeschreven tekst ("x5m").

   Gebruikt vanuit assets/df-header.js (blok, ververs, tussenkop) en op de
   resultatenpagina (sections/df-zoekresultaten.liquid, [data-df-zr-auto]).

   Sinds 19-10-2026 (bezoekerstest Z-1, bezoekers 3 en 5) herkent het ook
   een dienst: "keramische coating" zette een shampoo bovenaan en de
   detailingpagina op twee, "golf 7 gti chiptuning" Stage 1 pas op plek 8.
   Wie zo'n woord typt krijgt de dienst nu als eerste blok, voor de
   producten; de Shopify-resultaten eronder blijven zoals ze waren.
   ========================================================================== */
(function () {
  'use strict';
  if (window.DFZoekAuto) return;

  var EN = String(document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var T = EN ? {
    jouwAuto: 'Your car', producten: 'Products', kenteken: 'Licence plate',
    zoekKt: 'Look up plate ', ktSub: 'We check which car it is and show what fits',
    alles: 'Everything that fits', voorAuto: ' for your car', alleenPassend: 'Only the parts that fit',
    meer: ' more, choose your car', merkAlle: 'All ', merkDelen: ' parts',
    merkSub: 'Add your model or chassis code, for example m4 or g82',
    merkVb: 'For example ', of: ' or ',
    zrAuto: 'Your car', zrKop: 'Parts for ', zrHint: 'Click your car and you only see what fits.',
    zrKt: 'Look up plate ',
    diensten: 'Services', dienstSub: 'More about this service', dienstCol: 'View the collection',
    zrDienst: 'Click through for details and prices.'
  } : {
    jouwAuto: 'Jouw auto', producten: 'Producten', kenteken: 'Kenteken',
    zoekKt: 'Zoek op kenteken ', ktSub: 'We kijken welke auto het is en laten zien wat erop past',
    alles: 'Alles wat past', voorAuto: ' voor jouw auto', alleenPassend: 'Alleen de delen die passen',
    meer: ' andere, kies je auto', merkAlle: 'Alle ', merkDelen: ' onderdelen',
    merkSub: 'Typ je model of chassiscode erbij, bijvoorbeeld m4 of g82',
    merkVb: 'Bijvoorbeeld ', of: ' of ',
    zrAuto: 'Jouw auto', zrKop: 'Onderdelen voor ', zrHint: 'Klik je auto aan, dan zie je alleen wat past.',
    zrKt: 'Zoek op kenteken ',
    diensten: 'Diensten', dienstSub: 'Meer over deze dienst', dienstCol: 'Bekijk de collectie',
    zrDienst: 'Klik door voor uitleg en prijzen.'
  };

  function plat(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim(); }

  var ONDERDELEN = [
    { woorden: ['bodykit', 'bodykits', 'body kit', 'widebody', 'wide body', 'kit'], label: 'Bodykits', en: 'Body kits', types: ['Widebody Kit', 'Bodykit Set', 'Bodykit onderdeel'] },
    { woorden: ['splitter', 'splitters', 'front splitter', 'frontsplitter', 'lip', 'voorlip', 'frontlip', 'front lip'], label: 'Front splitters', en: 'Front splitters', types: ['Front Splitter'] },
    { woorden: ['skirts', 'skirt', 'side skirts', 'sideskirts', 'sideskirt', 'dorpels'], label: 'Side skirts', en: 'Side skirts', types: ['Side Skirts'] },
    { woorden: ['diffuser', 'diffusers', 'diffusor'], label: 'Diffusers', en: 'Diffusers', types: ['Diffuser'] },
    { woorden: ['spoiler', 'spoilers', 'vleugel', 'achtervleugel', 'wing', 'dakspoiler', 'kofferdekselspoiler', 'ducktail'], label: 'Spoilers', en: 'Spoilers', types: ['Spoiler', 'Achtervleugel'] },
    /* 20-10-2026 (afronding typen): EN-label "Bonnets" in plaats van "Hoods". */
    { woorden: ['motorkap', 'motorkappen', 'bonnet', 'bonnets', 'hood', 'hoods'], label: 'Motorkappen', en: 'Bonnets', types: ['Motorkap'] },
    { woorden: ['spiegelkappen', 'spiegelkap', 'spiegels', 'mirror', 'mirrors'], label: 'Spiegelkappen', en: 'Mirror caps', types: ['Spiegelkappen'] },
    { woorden: ['grille', 'grilles', 'nieren', 'niergrille', 'grill'], label: 'Grilles', en: 'Grilles', types: ['Grille'] },
    { woorden: ['intake', 'intakes', 'inlaat', 'luchtinlaat', 'airbox', 'eventuri'], label: 'Intakes', en: 'Intakes', types: ['Carbon Intake'] },
    { woorden: ['canards', 'canard'], label: 'Canards', en: 'Canards', types: ['Canards'] },
    { woorden: ['vents', 'vent', 'luchtuitlaten'], label: 'Vents', en: 'Vents', types: ['Vents'] },
    { woorden: ['interieur', 'interior'], label: 'Interieur', en: 'Interior', types: ['Interieur'] },
    { woorden: ['spatborden', 'spatbord', 'fenders'], label: 'Spatborden', en: 'Fenders', types: ['Spatborden'] }
  ];
  var MERK_ALIAS = { vw: 'volkswagen', mercedes: 'mercedes benz', merc: 'mercedes benz', amg: 'mercedes benz' };

  /* Diensten (19-10-2026, bezoekerstest Z-1). De woorden zijn ruim, met de
     tikfouten die bezoekers echt maken (bleu eye, boormod3); die ruimte geldt
     alleen voor dit blok. Een woord telt als het heel in de zoekterm staat,
     of (vanaf vijf tekens) als begin van een getypt woord: "coatings" en
     "laserjammer" tellen dus mee, "chipset" niet. Het pad is zonder
     taalvoorvoegsel; lokaal() zet dat er op /en-eu/ voor. */
  var DIENSTEN = [
    { woorden: ['coating', 'keramisch', 'keramische', 'ceramic', 'detailing', 'polijsten', 'poetsen', 'wassen', 'lakcorrectie', 'polish', 'polishing'],
      label: 'Detailing en keramische coating', en: 'Detailing and ceramic coating', pad: '/pages/detailing', code: 'DET' },
    /* 19-10-2026 (Z-11, na de antwoorden van Luuk): ook automaat, dsg en apk
       wijzen naar chiptuning; een automaat tunen we altijd mee en Stage 1 komt
       gewoon door de APK. */
    { woorden: ['chiptuning', 'chip', 'tune', 'tunen', 'tuning', 'stage 1', 'stage1', 'pk', 'vermogen', 'tcu', 'dsg', 'automaat', 'apk', 'remap'],
      label: 'Chiptuning Stage 1', en: 'ECU tuning Stage 1', pad: '/pages/chiptuning', code: 'ST1' },
    /* 19-10-2026 (reviewer Z-1): 'inbouw' telt alleen nog naast een ander
       Blu Eye-woord (bij). Los gaf "carplay inbouwen" of "dashcam inbouwen"
       eerst de Blu Eye-pagina, boven de producten waar het om ging.
       20-10-2026 (ronde 3, spoor thema, punt 5): met "inbouw" of "inbouwen"
       erbij tellen ook de losse woorden blu, blue, bleu, eye, target en
       hulpdiensten (metInbouw): "blu inbouwen" en "eye inbouw" geven het
       blok wel, "inbouwen" alleen nog steeds niet. */
    { woorden: ['blu eye', 'blue eye', 'bleu eye', 'blueye', 'blu eye go', 'blue eye go', 'bleu eye go', 'blueye go', 'blu eye 2', 'blue eye 2', 'target', 'hulpdiensten', 'politie', 'police'],
      bij: ['inbouw'],
      metInbouw: ['blu', 'blue', 'bleu', 'eye', 'target', 'hulpdiensten'],
      label: 'Target Blu Eye', en: 'Target Blu Eye', pad: '/pages/target-blu-eye', code: 'BLU' },
    { woorden: ['bootmod3', 'bootmod', 'boormod3', 'bm3'],
      label: 'bootmod3', en: 'bootmod3', pad: '/pages/bootmod3', code: 'BM3' },
    { woorden: ['lasertrack', 'laser'],
      label: 'LaserTrack', en: 'LaserTrack', pad: '/collections/lasertrack', code: 'LT' },
    /* Leenauto (19-10-2026, Z-11, vraag 15): de Toyota Yaris huur je per dag.
       Na de reviewer (19-10-2026): de prijs staat niet meer vast in dit
       script maar komt uit het product zelf (prijsUit, zie haalPrijs), en de
       Engelse naam volgt het product ("Loaner Car"). {p} is de plek van de
       prijs; zonder prijs (nog niet binnen of niet op te halen) staat er
       het label zonder bedrag. */
    /* 20-10-2026 (ronde 3, spoor thema, punt 5): geen prijs meer in de regel,
       ook niet uit het product: "Leenauto huren" / "Rent a loaner car". De
       prijs staat op de productpagina en in de productrij van Shopify.
       prijsUit staat daarom uit; haalPrijs en dienstLabel blijven werken
       voor een dienst die het later wel wil. */
    { woorden: ['leenauto', 'leen auto', 'vervangend vervoer', 'loaner car', 'loaner', 'courtesy car', 'loan car'],
      label: 'Leenauto huren', en: 'Rent a loaner car',
      sub: 'Toyota Yaris, terwijl wij aan je auto werken', enSub: 'Toyota Yaris, while we work on your car',
      pad: '/products/leenauto-per-dag', code: 'LA' }
  ];

  function haalDiensten(delen) {
    var tekst = ' ' + delen.join(' ') + ' ';
    var uit = [];
    var rest = tekst;
    DIENSTEN.forEach(function (d) {
      var tref = [];
      d.woorden.forEach(function (w) {
        var heel = tekst.indexOf(' ' + w + ' ') !== -1;
        var begin = w.length >= 5 && tekst.indexOf(' ' + w) !== -1;
        if (heel || begin) tref.push(w);
      });
      /* 20-10-2026 (ronde 3, punt 5): een los Blu Eye-woord telt alleen naast
         een woord dat met inbouw begint, zie metInbouw. */
      if (!tref.length && d.metInbouw && tekst.indexOf(' inbouw') !== -1) {
        d.metInbouw.forEach(function (w) {
          var heel = tekst.indexOf(' ' + w + ' ') !== -1;
          var begin = w.length >= 5 && tekst.indexOf(' ' + w) !== -1;
          if (heel || begin) tref.push(w);
        });
      }
      if (!tref.length) return;
      (d.bij || []).forEach(function (w) { if (tekst.indexOf(' ' + w) !== -1) tref.push(w); });
      uit.push(d);
      /* De dienstwoorden gaan uit de tekst, zodat "golf 7 gti chiptuning"
         daarna gewoon de Golf 7 GTI oplevert. */
      tref.sort(function (a, b) { return b.length - a.length; });
      tref.forEach(function (w) { rest = rest.replace(new RegExp(' ' + w + '[a-z0-9]*(?= )', 'g'), ' '); });
    });
    return { diensten: uit, rest: plat(rest).split(' ').filter(Boolean) };
  }

  /* Prijs uit het product (19-10-2026, reviewer Z-11). Eenmalig per
     bezoek: /products/<handle>.js geeft de prijs in centen in de valuta van
     de markt. Alleen euro's tonen we; anders blijft het label zonder bedrag.
     Zodra de prijs binnen is, worden de labels die al op de pagina staan
     bijgewerkt (data-df-dienst-label). */
  var PRIJS = {};
  function bedragUitCent(c) {
    var heel = Math.floor(c / 100), cent = c % 100;
    var m = String(heel).replace(/\B(?=(\d{3})+(?!\d))/g, EN ? ',' : '.');
    if (!cent) return '\u20ac' + m + (EN ? '' : ',-');
    return '\u20ac' + m + (EN ? '.' : ',') + (cent < 10 ? '0' + cent : cent);
  }
  function haalPrijs(d) {
    if (!d.prijsUit || PRIJS.hasOwnProperty(d.pad)) return;
    PRIJS[d.pad] = null;
    var valuta = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (valuta && valuta !== 'EUR') { PRIJS[d.pad] = ''; return; }
    fetch(lokaal(d.pad) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var c = p && typeof p.price === 'number' ? p.price : null;
        PRIJS[d.pad] = c !== null && c > 0 ? bedragUitCent(c) : '';
      }, function () { PRIJS[d.pad] = ''; })
      .then(function () {
        if (!PRIJS[d.pad]) return;
        Array.prototype.slice.call(document.querySelectorAll('[data-df-dienst-label="' + d.code + '"]')).forEach(function (n) { n.textContent = dienstLabel(d); });
      })
      .catch(function () {});
  }
  function dienstLabel(d) {
    if (!d.prijsUit) return EN && d.en ? d.en : d.label;
    var p = PRIJS[d.pad];
    if (!p) return EN ? d.enZonder : d.zonder;
    return (EN ? d.en : d.label).replace('{p}', p);
  }
  function dienstSub(d) {
    if (d.sub) return EN && d.enSub ? d.enSub : d.sub;
    return d.pad.indexOf('/collections/') === 0 ? T.dienstCol : T.dienstSub;
  }

  /* Het taalvoorvoegsel voor eigen paden: op /en-eu/ geeft Shopify.routes.root
     "/en-eu/", op de Nederlandse site "/". Ontbreekt dat, dan komt het uit de
     eerste collectie-url van de autolijst, die het voorvoegsel al draagt. */
  function wortel() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!r) {
      var l = lijst();
      r = l.length && l[0].u.indexOf('/collections/') > 0 ? l[0].u.split('/collections/')[0] + '/' : '/';
    }
    return String(r).replace(/\/$/, '');
  }
  function lokaal(pad) { return wortel() + pad; }

  function bereid(autos) {
    return autos.map(function (r) {
      var tekst = plat(r.m + ' ' + r.g + ' ' + r.l);
      return { m: r.m, g: r.g, l: r.l, u: r.u, p: ' ' + tekst + ' ', aan: tekst.replace(/ /g, ''), codes: plat(r.l.split('(')[0]).split(' ') };
    });
  }

  /* Alle manieren om buurtokens aan elkaar te plakken, meest geplakt eerst:
     ["rs","3"] -> ["rs3"] en ["rs","3"]. */
  function lezingen(delen) {
    if (delen.length <= 1) return [delen];
    var uit = [];
    var rest = lezingen(delen.slice(1));
    rest.forEach(function (r) { uit.push([delen[0] + r[0]].concat(r.slice(1))); });
    rest.forEach(function (r) { uit.push([delen[0]].concat(r)); });
    return uit;
  }

  function haalOnderdeel(delen) {
    var tekst = ' ' + delen.join(' ') + ' ';
    var beste = null;
    ONDERDELEN.forEach(function (o) {
      o.woorden.forEach(function (w) {
        var i = tekst.indexOf(' ' + w + ' ');
        if (i !== -1 && (!beste || w.length > beste.w.length)) beste = { o: o, w: w };
      });
    });
    if (!beste) return { onderdeel: null, rest: delen };
    var rest = plat(tekst.replace(' ' + beste.w + ' ', ' ')).split(' ').filter(Boolean);
    return { onderdeel: beste.o, rest: rest };
  }

  /* Een Nederlands kenteken: zes tekens in een van de sidecodes, en zonder
     spaties getypt. "a45 amg" is een auto, "RJ-066-B" en "rj066b" een plaat. */
  var SIDECODES = [/^[A-Z]{2}\d{4}$/, /^\d{2}[A-Z]{2}\d{2}$/, /^\d{4}[A-Z]{2}$/, /^[A-Z]{2}\d{2}[A-Z]{2}$/, /^[A-Z]{4}\d{2}$/, /^\d{2}[A-Z]{4}$/, /^\d{2}[A-Z]{3}\d$/, /^\d[A-Z]{3}\d{2}$/, /^[A-Z]{2}\d{3}[A-Z]$/, /^[A-Z]\d{3}[A-Z]{2}$/, /^[A-Z]{3}\d{2}[A-Z]$/, /^[A-Z]\d{2}[A-Z]{3}$/, /^\d[A-Z]{2}\d{3}$/, /^\d{3}[A-Z]{2}\d$/];
  function isKenteken(q) {
    if (/\s/.test(q.trim())) return null;
    var k = q.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (k.length !== 6) return null;
    for (var i = 0; i < SIDECODES.length; i++) if (SIDECODES[i].test(k)) return k;
    return null;
  }
  function kentekenNet(k) {
    var m = k.match(/^([A-Z]+|\d+)([A-Z]+|\d+)([A-Z]+|\d+)$/);
    if (m) return m[1] + '-' + m[2] + '-' + m[3];
    return k.slice(0, 2) + '-' + k.slice(2, 4) + '-' + k.slice(4);
  }

  function zoekAutos(lijst, delen) {
    if (!delen.length) return [];
    var woorden = delen.map(function (d) { return MERK_ALIAS[d] || d; });
    var lez = lezingen(woorden.join(' ').split(' '));
    for (var i = 0; i < lez.length; i++) {
      var treffers = lijst.filter(function (r) {
        for (var j = 0; j < lez[i].length; j++) if (r.p.indexOf(' ' + lez[i][j]) === -1) return false;
        return true;
      });
      if (treffers.length) return rangschik(treffers, lez[i]);
    }
    var aanEen = woorden.join('');
    if (aanEen.length >= 3) return rangschik(lijst.filter(function (r) { return r.aan.indexOf(aanEen) !== -1; }), [aanEen]);
    return [];
  }

  /* Een chassiscode die precies in het label staat wint van een losse treffer
     op de modelgroep; nieuwer eerst binnen gelijke score.
     20-10-2026 (ronde 3, spoor thema, punt 5): een open bereik ("(2024+)")
     loopt nog door en telt dus als nieuwer dan elk gesloten bereik, ook
     "(2014-2024)". Eerst eindigden die allebei op 2024 en besliste het
     alfabet, zodat de nieuwste Mini Cooper zakte bij "mini", "mini cooper",
     "cooper" en "cooper splitter". Twee open bereiken: het latere beginjaar
     eerst. */
  function rangschik(treffers, tokens) {
    function jaren(l) {
      var m = String(l).match(/(19|20)\d{2}/g) || [];
      var open = /(19|20)\d{2}\s*\+/.test(String(l));
      var eind = m.length ? parseInt(m[m.length - 1], 10) : 0;
      return { e: open ? 9999 : eind, b: m.length ? parseInt(m[0], 10) : 0 };
    }
    return treffers.map(function (r) {
      var score = 0;
      tokens.forEach(function (t) { if (r.codes.indexOf(t) !== -1) score += 2; else if (r.p.indexOf(' ' + t + ' ') !== -1) score += 1; });
      var jr = jaren(r.l);
      return { r: r, s: score, j: jr.e, b: jr.b };
    }).sort(function (a, b) { return b.s - a.s || b.j - a.j || b.b - a.b || a.r.l.localeCompare(b.r.l); }).map(function (x) { return x.r; });
  }

  function herken(lijst, q) {
    var delen = plat(q).split(' ').filter(Boolean);
    var kt = isKenteken(q);
    /* Een kenteken is nooit een dienst, dus bij een plaat slaan we de
       dienstwoorden over. */
    var ds = kt ? { diensten: [], rest: delen } : haalDiensten(delen);
    var od = haalOnderdeel(ds.rest);
    var autos = zoekAutos(lijst, od.rest);
    var onderdeelAlleen = od.onderdeel && !od.rest.length;
    var merkAlleen = null;
    if (autos.length > 3) {
      var merk = autos[0].m;
      var zelfde = autos.every(function (a) { return a.m === merk; });
      var restTekst = od.rest.map(function (d) { return MERK_ALIAS[d] || d; }).join(' ');
      if (zelfde && plat(merk) === restTekst) merkAlleen = merk;
    }
    return { delen: delen, kenteken: kt, onderdeel: od.onderdeel, autos: autos, onderdeelAlleen: onderdeelAlleen, merkAlleen: merkAlleen, rest: od.rest, diensten: ds.diensten };
  }

  /* 20-10-2026 (afronding typen): op /en-eu/ filtert Shopify op de Engelse
     vertaling van custom.type. Elke typewaarde heeft sinds vandaag een vaste
     EN-vertaling (TYPEN/mapping.csv); de Nederlandse waarden liepen daar dood
     (Motorkap, Spiegelkappen, Achtervleugel, Bodykit, Interieur, Spatborden).
     Typen die in beide talen gelijk zijn staan niet in de tabel. */
  var TYPE_EN = {
    'Spiegelkappen': 'Mirror caps', 'Motorkap': 'Bonnet', 'Bodykit onderdeel': 'Body kit part',
    'Achtervleugel': 'Rear wing', 'Interieur': 'Interior', 'Spatborden': 'Fenders',
    'Bodykit Set': 'Body Kit Set'
  };
  function typeParams(onderdeel) {
    return onderdeel.types.map(function (t) {
      return 'filter.p.m.custom.type=' + encodeURIComponent(EN && TYPE_EN[t] ? TYPE_EN[t] : t);
    }).join('&');
  }

  function filterUrl(auto, onderdeel) {
    return auto.u + '?' + typeParams(onderdeel);
  }


  function onderdeelLabel(o) { return EN && o.en ? o.en : o.label; }

  /* ---------- de autolijst, eenmalig uit de pagina ---------- */
  var cache = null;
  function lijst() {
    if (cache) return cache;
    var bron = document.querySelector('[data-dfa-autos]');
    var rijen = [];
    if (bron) { try { rijen = JSON.parse(bron.textContent) || []; } catch (e) { rijen = []; } }
    cache = bereid(rijen);
    return cache;
  }

  /* Het korte kenmerk vooraan een rij: de chassiscode uit het label, anders
     het eerste woord. "G82 / G83 M4 (2021+)" wordt G82, "Golf 7" wordt GOLF. */
  function codeVan(label) {
    var delen = String(label || '').split('(')[0].trim().split(/\s+/);
    for (var i = 0; i < delen.length; i++) {
      var d = delen[i].replace(/[^A-Za-z0-9.]/g, '');
      if (/^[A-Za-z]{1,2}\d{1,3}(\.\d)?$/.test(d) || /^\d[A-Za-z]$/.test(d) || /^(MK|Mk)\d/.test(d)) return d.toUpperCase().slice(0, 5);
    }
    return (delen[0] || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 5) || '·';
  }

  function el(tag, klasse, tekst) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (tekst != null) e.textContent = tekst;
    return e;
  }

  /* Zelfde bewaarplek als de autokiezer (df-auto.js): wie zijn auto aanklikt
     heeft hem gekozen, en de menubalk toont hem daarna als "Jouw auto". */
  function onthoud(a) {
    try { localStorage.setItem('df_auto', JSON.stringify({ merk: a.m, groep: a.g, label: a.l, url: a.u })); } catch (e) { /* laat maar */ }
  }

  /* Een kenteken uit de zoekbalk gaat naar de kentekenplaat in de autokiezer,
     die de opzoeking en de keuze tussen generaties al kent. */
  function zoekKenteken(kt) {
    var hdr = document.querySelector('.hdr');
    var paneel = document.getElementById('autokiezer');
    var tog = hdr ? hdr.querySelector('.ftog') : null;
    var vorm = paneel ? paneel.querySelector('form[data-dfa-kt]') : null;
    var veld = vorm ? vorm.querySelector('[data-dfa-kt-input]') : null;
    /* 20-10-2026 (restpunt ronde 4): ook de terugval via lokaal(), anders
       viel /en-eu/ terug op de Nederlandse chiptuningpagina. */
    if (!hdr || !vorm || !veld) {
      window.location.href = lokaal('/pages/chiptuning') + '?kenteken=' + encodeURIComponent(kt);
      return;
    }
    hdr.classList.remove('zoekopen');
    if (!hdr.classList.contains('fopen')) {
      if (tog) tog.click(); else hdr.classList.add('fopen');
    }
    veld.value = kt;
    veld.dispatchEvent(new Event('input', { bubbles: true }));
    vorm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function openKiezer() {
    var hdr = document.querySelector('.hdr');
    var tog = hdr ? hdr.querySelector('.ftog') : null;
    if (!hdr) return;
    hdr.classList.remove('zoekopen');
    if (!hdr.classList.contains('fopen')) { if (tog) tog.click(); else hdr.classList.add('fopen'); }
  }

  /* ---------- rijen voor het uitklapmenu ---------- */
  function kop(tekst, auto) {
    return el('div', 'df-zoek__kop' + (auto ? ' df-zoek__kop--auto' : ''), tekst);
  }

  function rijAuto(a, onderdeel) {
    var r = el('a', 'df-zoek__rij df-zoek__rij--auto');
    r.href = onderdeel ? filterUrl(a, onderdeel) : a.u;
    r.setAttribute('role', 'option');
    r.appendChild(el('span', 'df-zoek__code', codeVan(a.l)));
    var tx = el('div', 'df-zoek__tx');
    tx.appendChild(el('b', null, a.m + ' ' + a.l));
    tx.appendChild(el('span', null, onderdeel ? T.alleenPassend : T.alles));
    r.appendChild(tx);
    r.appendChild(el('span', 'df-zoek__pijl', '→'));
    r.addEventListener('click', function () { onthoud(a); });
    return r;
  }

  /* 20-10-2026 (restpunt ronde 4): de merkrij ("Alle Tesla onderdelen",
     "All Tesla parts") linkte zonder taalvoorvoegsel, dus op /en-eu/ naar de
     Nederlandse shop. Nu via lokaal(), net als de diensten. De autorijen
     (a.u uit [data-dfa-autos]) dragen het voorvoegsel al zelf. */
  /* 20-10-2026 (restpunt ronde 4): het voorbeeld onder de merkrij was altijd
     "m4 of g82", ook bij Tesla of Audi. Bij BMW blijft dat; bij een ander
     merk staan de eerste twee modelgroepen uit de autolijst ("model y of
     model 3"). */
  /* 20-10-2026 (restpunt ronde 4, herstel): op een telefoon viel het
     voorbeeld achter de aanloop "Typ je model erbij" weg. Nu staat het
     voorbeeld vooraan ("Bijvoorbeeld model 3 of model s"), ook bij BMW. */
  function merkVoorbeeld(merk, autos) {
    if (plat(merk) === 'bmw') return T.merkVb + 'm4' + T.of + 'g82';
    var vb = [];
    (autos || []).forEach(function (a) {
      var g = String(a.g || '').split('/')[0].trim().toLowerCase();
      if (g && vb.indexOf(g) === -1 && vb.length < 2) vb.push(g);
    });
    return vb.length ? T.merkVb + vb.join(T.of) : T.merkSub;
  }

  /* 20-10-2026 (restpunt ronde 4, herstel): staat er een onderdeel in de
     zoekterm ("bmw spoiler"), dan gaat de merkrij naar dat onderdeel van het
     merk ("BMW spoilers"), met dezelfde typefilters als de autorijen. */
  function rijMerk(merk, autos, onderdeel) {
    var r = el('a', 'df-zoek__rij df-zoek__rij--auto');
    r.href = lokaal('/collections/all') + '?filter.p.m.custom.make=' + encodeURIComponent(merk) +
      (onderdeel ? '&' + typeParams(onderdeel) : ''); /* 20-10-2026: EN-typewaarden via typeParams */
    r.setAttribute('role', 'option');
    r.appendChild(el('span', 'df-zoek__code df-zoek__code--merk', merk.replace(/[^A-Za-z0-9]/g, '').slice(0, 3).toUpperCase()));
    var tx = el('div', 'df-zoek__tx');
    tx.appendChild(el('b', null, onderdeel ? merk + ' ' + onderdeelLabel(onderdeel).toLowerCase() : T.merkAlle + merk + T.merkDelen));
    tx.appendChild(el('span', null, merkVoorbeeld(merk, autos)));
    r.appendChild(tx);
    r.appendChild(el('span', 'df-zoek__pijl', '→'));
    return r;
  }

  /* Een dienst in het uitklapmenu (19-10-2026, Z-1): kort kenmerk vooraan
     in het rood van de merkrij, de naam van de dienst, en een regel eronder. */
  function rijDienst(d) {
    var r = el('a', 'df-zoek__rij df-zoek__rij--auto');
    r.href = lokaal(d.pad);
    r.setAttribute('role', 'option');
    r.appendChild(el('span', 'df-zoek__code df-zoek__code--merk', d.code));
    var tx = el('div', 'df-zoek__tx');
    var lb = el('b', null, dienstLabel(d));
    lb.setAttribute('data-df-dienst-label', d.code);
    tx.appendChild(lb);
    tx.appendChild(el('span', null, dienstSub(d)));
    r.appendChild(tx);
    r.appendChild(el('span', 'df-zoek__pijl', '\u2192'));
    r.setAttribute('data-df-dienst-pad', d.pad);
    haalPrijs(d);
    return r;
  }

  /* Dubbele rij weg (19-10-2026, reviewer Z-11): wijst een dienst naar een
     product, dan haalt Shopify dat product vaak ook op en stond het direct
     onder de dienst nog een keer. De productrij met hetzelfde pad gaat eruit;
     blijft er dan geen productrij over, dan ook de tussenkop "Producten".
     Draait na de rest van toon() in df-header.js (setTimeout 0). */
  function ontdubbel(wrap) {
    var bak = wrap && wrap.parentNode;
    if (!bak) return;
    var paden = Array.prototype.slice.call(wrap.querySelectorAll('[data-df-dienst-pad^="/products/"]')).map(function (n) { return n.getAttribute('data-df-dienst-pad'); });
    if (!paden.length) return;
    var weg = 0;
    Array.prototype.slice.call(bak.querySelectorAll('a.df-zoek__rij:not(.df-zoek__rij--auto)')).forEach(function (a) {
      var pad = '';
      try { pad = new URL(a.href, window.location.href).pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/, ''); } catch (e) { pad = ''; }
      if (paden.indexOf(pad) !== -1) { a.parentNode.removeChild(a); weg++; }
    });
    if (weg && !bak.querySelector('.df-zoek__rij:not(.df-zoek__rij--auto)')) {
      Array.prototype.slice.call(bak.querySelectorAll('[data-df-zoek-tussenkop]')).forEach(function (n) { n.parentNode.removeChild(n); });
    }
  }

  function rijKenteken(kt) {
    var net = kentekenNet(kt);
    var r = el('button', 'df-zoek__rij df-zoek__rij--auto');
    r.type = 'button';
    r.setAttribute('role', 'option');
    var plaat = el('span', 'df-zoek__plaat');
    plaat.appendChild(el('i', null, 'NL'));
    plaat.appendChild(document.createTextNode(net));
    r.appendChild(plaat);
    var tx = el('div', 'df-zoek__tx');
    tx.appendChild(el('b', null, T.zoekKt + net));
    tx.appendChild(el('span', null, T.ktSub));
    r.appendChild(tx);
    r.appendChild(el('span', 'df-zoek__pijl', '→'));
    r.addEventListener('click', function () { zoekKenteken(net); });
    return r;
  }

  /* Het autoblok voor een zoekterm, of null als er niets in zit. */
  function blok(q) {
    q = String(q || '').trim();
    if (q.length < 2) return null;
    var r = herken(lijst(), q);
    if (!r.kenteken && !r.autos.length && !r.merkAlleen && !r.diensten.length) return null;
    var wrap = el('div', 'df-zoek__auto');
    wrap.setAttribute('data-df-zoek-auto', '');
    /* De dienst eerst (19-10-2026, Z-1): wie "chiptuning" typt zoekt de
       dienst, de auto erachter is de tweede stap. */
    if (r.diensten.length) {
      wrap.appendChild(kop(T.diensten, true));
      r.diensten.slice(0, 3).forEach(function (d) { wrap.appendChild(rijDienst(d)); });
      setTimeout(function () { ontdubbel(wrap); }, 0);
    }
    if (r.kenteken) {
      wrap.appendChild(kop(T.kenteken, true));
      wrap.appendChild(rijKenteken(r.kenteken));
    }
    if (r.merkAlleen) {
      wrap.appendChild(kop(r.onderdeel ? onderdeelLabel(r.onderdeel) + T.voorAuto : T.jouwAuto, true));
      wrap.appendChild(rijMerk(r.merkAlleen, r.autos, r.onderdeel));
    } else if (r.autos.length) {
      wrap.appendChild(kop(r.onderdeel ? onderdeelLabel(r.onderdeel) + T.voorAuto : T.jouwAuto, true));
      r.autos.slice(0, 3).forEach(function (a) { wrap.appendChild(rijAuto(a, r.onderdeel)); });
      if (r.autos.length > 3) {
        var meer = el('button', 'df-zoek__meer', (EN ? '' : 'Nog ') + (r.autos.length - 3) + T.meer);
        meer.type = 'button';
        meer.addEventListener('click', openKiezer);
        wrap.appendChild(meer);
      }
    }
    return wrap;
  }

  /* Scheiding tussen het autoblok en de producten van Shopify eronder. */
  function tussenkop() {
    var f = document.createDocumentFragment();
    var lijn = el('div', 'df-zoek__lijn'); lijn.setAttribute('data-df-zoek-tussenkop', '');
    var k = kop(T.producten, false); k.setAttribute('data-df-zoek-tussenkop', '');
    f.appendChild(lijn); f.appendChild(k);
    return f;
  }

  /* Bij elke aanslag: het autoblok meteen verversen, zonder op Shopify te
     wachten. De productrijen van de vorige vraag blijven staan tot de nieuwe
     binnen zijn; dat is het gedrag dat er al was. */
  function ververs(zoekUit, q) {
    if (!zoekUit) return;
    Array.prototype.slice.call(zoekUit.querySelectorAll('[data-df-zoek-auto],[data-df-zoek-tussenkop]')).forEach(function (n) { n.parentNode.removeChild(n); });
    var b = blok(q);
    if (!b) return;
    var niks = zoekUit.querySelector('.df-zoek__niks');
    if (niks) niks.parentNode.removeChild(niks);
    var heeftRijen = !!zoekUit.querySelector('.df-zoek__rij:not(.df-zoek__rij--auto)');
    if (heeftRijen) zoekUit.insertBefore(tussenkop(), zoekUit.firstChild);
    zoekUit.insertBefore(b, zoekUit.firstChild);
    zoekUit.hidden = false;
  }

  /* ---------- de resultatenpagina ---------- */
  function resultaten() {
    var bak = document.querySelector('[data-df-zr-auto]');
    if (!bak) return;
    var q = '';
    try { q = new URL(window.location.href).searchParams.get('q') || ''; } catch (e) { q = ''; }
    q = q.trim();
    if (q.length < 2) return;
    var r = herken(lijst(), q);
    /* 20-10-2026 (ronde 3, spoor thema, punt 5): wijst een dienst naar een
       product dat ook al als kaart in de resultaten staat (de leenauto), dan
       geen tweede regel daarvoor in het donkere blok.
       20-10-2026 (ronde 3, reviewer punt 5): de productkaarten op de
       zoekpagina staan in df-productgrid (.df-pgr__grid), niet in
       .df-zr__grid; beide roosters tellen nu mee. Vergeleken wordt het pad
       zonder taalvoorvoegsel (/en-eu), zodat /products/leenauto-per-dag-x
       niet per ongeluk meetelt. */
    r.diensten = r.diensten.filter(function (d) {
      if (d.pad.indexOf('/products/') !== 0) return true;
      var kaarten = document.querySelectorAll('.df-pgr__grid a[href], .df-zr__grid a[href]');
      for (var i = 0; i < kaarten.length; i++) {
        if (bak.contains(kaarten[i])) continue;
        var p = (kaarten[i].pathname || '').replace(/^\/[a-z]{2}(-[a-z0-9]{2,})?(?=\/products\/)/i, '').replace(/\/$/, '');
        if (p === d.pad) return false;
      }
      return true;
    });
    var heeftAuto = !!(r.kenteken || (r.autos.length && !r.merkAlleen));
    if (!heeftAuto && !r.diensten.length) return;
    while (bak.firstChild) bak.removeChild(bak.firstChild);
    /* Twee delen in hetzelfde donkere blok (19-10-2026, Z-1): eerst de
       dienst, daaronder de auto; de scheidslijn staat in
       df-zoekresultaten.liquid (.df-zr__auto-deel). */
    if (r.diensten.length) {
      var dl = el('div', 'df-zr__auto-deel');
      dl.appendChild(el('div', 'df-zr__auto-eyebrow', T.diensten));
      var dk = el('div', 'df-zr__auto-kop', dienstLabel(r.diensten[0]));
      dk.setAttribute('data-df-dienst-label', r.diensten[0].code);
      dl.appendChild(dk);
      var stripD = el('div', 'df-zr__auto-strip');
      r.diensten.slice(0, 3).forEach(function (d, i) {
        var c = el('a', 'df-zr__chip' + (i === 0 ? ' df-zr__chip--aan' : ''));
        c.href = lokaal(d.pad);
        c.appendChild(el('span', 'df-zr__code', d.code));
        /* Het label in een eigen span, zodat haalPrijs het kan bijwerken
           (19-10-2026, reviewer Z-11). */
        var ct = el('span', null, dienstLabel(d));
        ct.setAttribute('data-df-dienst-label', d.code);
        c.appendChild(ct);
        haalPrijs(d);
        stripD.appendChild(c);
      });
      dl.appendChild(stripD);
      dl.appendChild(el('p', 'df-zr__auto-sub', T.zrDienst));
      bak.appendChild(dl);
    }
    if (heeftAuto) {
      var al = el('div', 'df-zr__auto-deel');
      al.appendChild(el('div', 'df-zr__auto-eyebrow', r.onderdeel && r.autos.length ? onderdeelLabel(r.onderdeel) + T.voorAuto : T.zrAuto));
      if (r.kenteken) {
        var net = kentekenNet(r.kenteken);
        al.appendChild(el('div', 'df-zr__auto-kop', T.zrKt + net));
        var strip0 = el('div', 'df-zr__auto-strip');
        var kn = el('button', 'df-zr__chip df-zr__chip--aan');
        kn.type = 'button';
        kn.appendChild(el('span', 'df-zr__code', 'NL'));
        kn.appendChild(document.createTextNode(net));
        kn.addEventListener('click', function () { zoekKenteken(net); });
        strip0.appendChild(kn);
        al.appendChild(strip0);
        al.appendChild(el('p', 'df-zr__auto-sub', T.ktSub));
      } else {
        var eerste = r.autos[0];
        al.appendChild(el('div', 'df-zr__auto-kop', (r.onderdeel ? onderdeelLabel(r.onderdeel) + (EN ? ' for ' : ' voor ') : T.zrKop) + eerste.m + ' ' + eerste.l));
        var strip = el('div', 'df-zr__auto-strip');
        r.autos.slice(0, 4).forEach(function (a, i) {
          var c = el('a', 'df-zr__chip' + (i === 0 ? ' df-zr__chip--aan' : ''));
          c.href = r.onderdeel ? filterUrl(a, r.onderdeel) : a.u;
          c.appendChild(el('span', 'df-zr__code', codeVan(a.l)));
          c.appendChild(document.createTextNode(a.m + ' ' + a.l));
          c.addEventListener('click', function () { onthoud(a); });
          strip.appendChild(c);
        });
        if (r.autos.length > 4) {
          var m = el('button', 'df-zr__chip', (EN ? '' : 'Nog ') + (r.autos.length - 4) + T.meer);
          m.type = 'button';
          m.addEventListener('click', openKiezer);
          strip.appendChild(m);
        }
        al.appendChild(strip);
        al.appendChild(el('p', 'df-zr__auto-sub', T.zrHint));
      }
      bak.appendChild(al);
    }
    bak.hidden = false;
  }

  window.DFZoekAuto = { blok: blok, ververs: ververs, tussenkop: tussenkop, herken: function (q) { return herken(lijst(), q); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', resultaten); else resultaten();
})();
